import React, { useContext,useState }  from 'react';
import { Link} from 'react-router-dom';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SideNav, { NavItem, NavIcon, NavText} from '@trendmicro/react-sidenav';
import NavLink from 'react-bootstrap/NavLink';
import { LabelText } from '../../../components/Language/LabelText';
import {businessPartnerNavItems, nmbsUserNavItems} from './NavItemsData';
import './index.css';
import config from '../../../common/const/sidebarConfig.json';
import FR from '../../../assets/images/FR nouveau.svg'
import DE from '../../../assets/images/DE neue.svg'
import EN from '../../../assets/images/EN new.svg'
import NL from '../../../assets/images/NL nieuw.svg'
import { LanguageContext } from '../../../containers/Language/LanguageProvider';

const NavHeader = styled.div`
    display: block;
    white-space: nowrap;
    background-color: #25336C;
    color: #fff;
    > * {
        color: inherit;
        background-color: inherit;
    }
`;

const NavTitle = styled.div`
    font-size: 1.3vw;
    line-height: 4vh;
    text-align: center;
    padding: 1.2vw 0;
`;

const Separator = styled.div`
    clear: both;
    position: relative;
    margin: .01rem 0;
    background-color: #ddd;
    height: 2px;
`;

const NavItemWithSubNav = (item, selectedItem) => {
    const [dropdown,setDropdown] = useState(true)   
    const [navKey,setnavKey] = useState("Expanded")  

    const navclick = () => {
        setDropdown(!dropdown)
        setnavKey(navKey === "Expanded" ? "Collapsed":"Expanded")
    }

    return (
        <NavItem key={navKey} eventKey={navKey} expanded={dropdown} onClick = {navclick}>
            <NavIcon>
                <FontAwesomeIcon icon={item.icon} />
            </NavIcon>  
            <NavText 
                // title={item.title}
                style={{display: "flex"}}>
                <div className="subnav-item-text"><span><LabelText tid={item.title} /></span></div>
                {item.secondaryIcon && 
                <div className="subnav-item-secondary-icon">
                <NavLink onContextMenu={(e)=>e.preventDefault()}><FontAwesomeIcon icon={item.secondaryIcon} /></NavLink>
                </div>
                }
            </NavText>
            {item.subNav.map(i=>(NavItems(i, selectedItem)))}
        </NavItem>
    );
}

const NavItems = (item, selectedNavItem) => {
    const {language} = useContext(LanguageContext);
    const currentYear = new Date().getFullYear();
    let imagesrc;
    if(language.id === "1"){
        imagesrc = EN ;
    }
    else if(language.id === "2"){
        imagesrc = FR ;
    }
    else if(language.id === "3"){
        imagesrc = NL ;
    }
    else{
        imagesrc = DE ;
    }
    return (
        <NavItem 
        // style={{pointerEvents: "none"}} 
        key={item.key} eventKey={item.key} active={selectedNavItem === item.key}>
            {item.icon && <NavIcon>
                <Link style={{pointerEvents: "all"}} to={item.to} >
                    <FontAwesomeIcon icon={item.icon} />
                </Link>
            </NavIcon>}
            <NavText 
                // title={item.title}
            >
                <Link id={item.key} style={{pointerEvents: "all"}} to={item.to}><LabelText tid={item.title} />
                    <img className = {item.title === "elearning" && currentYear === 2022 ? "newimage" : "newimagehide"} src={imagesrc}/>
                </Link>
            </NavText>
        </NavItem>
    );
}

const NavAndNavItems = (props) => {
    const items= props.isBusinessPartnerUser ? businessPartnerNavItems : props.isNmbsUser ? nmbsUserNavItems.filter(d=> (!d.isEditAccessOnly || (d.isEditAccessOnly && props.isEditAccess))) : [];
    return (<SideNav.Nav selected={props.selected} expanded={true} className="scroller">
                {items.map(item=>item.hasSubNav ? NavItemWithSubNav(item, props.selected) : NavItems(item, props.selected))}
            </SideNav.Nav>)
}

export default function Sidebar(props) {
    return (
            <SideNav onSelect={props.onSelect} expanded={props.expanded} onToggle={props.onToggle}>
				<NavHeader>
                    <NavTitle>{config.sidebarTitle}</NavTitle>
                </NavHeader>
                <Separator/>
                {props.selected && NavAndNavItems(props)}
                {/* <Separator /> */}
            </SideNav>
    );
}